<div class="card-inner-main-div">
  <div class="card-main-title border-bottom">
    <h4 class="card-title">{{ 'Distribution' | translate }}</h4>
  </div>
  <div class="tableColStyle without-borders-table only-header-border">
    @if (loadingExposureTaskDistribution) {
      <div class="comments-loader">
        <img src="assets/images/loader.gif">
      </div>
    }
    @if (!loadingExposureTaskDistribution) {
      <div class="table-responsive">
        <table class="table border-bottom">
          <thead>
            <tr>
              <th scope="col" class="pl-0">
                <a>{{ 'Site' | translate }}</a>
              </th>
              <th scope="col">
                <a>{{ 'Contribution' | translate }}</a>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (dist of exposureTaskDistributions; track trackByIndex($index)) {
              <tr>
                <td class="pl-0"><span class="font-700">{{dist?.orgLevelName}}</span></td>
                <td><span class="">{{dist.massContributionPercent}}%</span></td>
              </tr>
            }
            @if (exposureTaskDistributions && !exposureTaskDistributions.length) {
              <tr>
                <td colspan="2" class="no-data-available with-padding">{{errorMessage}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>